/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_One_Time_Modal_TitleInputs */

const es_user_profile_api_keys_one_time_modal_title = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu clave API`)
};

const en_user_profile_api_keys_one_time_modal_title = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your API key`)
};

/**
* | output |
* | --- |
* | "Your API key" |
*
* @param {User_Profile_Api_Keys_One_Time_Modal_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_one_time_modal_title = /** @type {((inputs?: User_Profile_Api_Keys_One_Time_Modal_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_One_Time_Modal_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_one_time_modal_title(inputs)
	return en_user_profile_api_keys_one_time_modal_title(inputs)
});
export { user_profile_api_keys_one_time_modal_title as "user.profile.api_keys.one_time_modal.title" }